<template>
	<div class="main-box">
		<div class="content">
			<div class="title-box flex-row">
				<span class="tit">设备列表</span>
				<span>*合并下单提交只能选择同类型，同厂家。</span>
			</div>
			<div class="list">
				<div class="item" v-for="(item,index) in list" :key="index">
					<div class="company flex-row">
<!--						<img class="c-img" :src="$imgUrl + item.archiveList[0].archive.conmentUrl" />-->
						<span>{{item.customerName}}</span>
					</div>
					<div class="device-list" v-for="(good,ind) in item.archiveList" :key="ind">
						<div class="devive-item flex-row">
							<div class="info flex-row">
								<div class="img" style="display: flex;align-items: center;">
									<el-checkbox v-model="good.archive.check"  @change="handleCheckChange(good)" size="medium" style="margin-right: 20px;">
									</el-checkbox>
<!--									<img :src="$imgUrl + good.archive.pictureUrl" />-->
									<img :src="good.archive.pictureUrl ? $imgUrl + good.archive.pictureUrl : require('../../assets/image/login/logo.png')" />
<!--                  detail.pictureUrl ? $imgUrl + detail.pictureUrl : require('../../assets/image/login/logo.png')-->
								</div>
								<div class="text" v-if="good.archive.serviceDictValue == 0">
									<p>{{good.archive.name}}</p>
									<p>设备容量：{{getRl('volume_kva',good.archive.volumeDictValue)}}</p>
<!--									<p>输出电压：{{ getDy('voltage_kv',good.archive.voltageDictValue)}}</p>-->
								</div>
                <div class="text" v-else>
                  <p>{{good.archive.name}}</p>
                  <p style="width: 186px">设备类型：{{ getSb('lighting_type',good.archive.lightingTypeValue)}}</p>
                </div>
							</div>
							<div>
                <div class="type" v-if="good.archive.serviceDictValue == 0">保电类</div>
                <div class="type" v-if="good.archive.serviceDictValue == 1">照明类</div>
                <div class="type" v-if="good.archive.serviceDictValue == 2">其他类</div>
              </div>
<!--							<div class="price">-->
<!--								￥{{good.totalMoney}}</div>-->
              <div>
                <el-input-number v-model="good.number" @change="updataNum(good)"  :min="1" :max="100" label="数量" disabled></el-input-number>
              </div>
							<div class="btns">
								<span @click="toDetail(good)">查看详细</span>
								<span @click="deleteGood(good.id)">移除列表</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="bot flex-row">
				<el-button type="warning" style="font-size: 20px;" @click="sumbit">申请服务</el-button>
			</div>

      <el-dialog
          :visible.sync="shopShow"
          width="50%"
          @close="handleClose">
        <div  class="phone">
          <div class="title">申请服务</div>
          <div class="message">
            <div style="display:flex;align-items: center;width: 450px;margin: 10px auto">
              <span style="width: 100px;">昵称:</span>
              <el-input v-model="name" placeholder="请输入昵称"></el-input>
            </div>
            <div style="display:flex;align-items: center;width: 450px;margin: 10px auto">
              <span style="width: 100px;">手机号:</span>
              <el-input v-model="phone" placeholder="请输入手机号"></el-input>
            </div>
            <div style="display:flex;align-items: center;width: 450px;margin: 10px auto">
              <span style="width: 100px;">留言:</span>
              <el-input v-model="remark" placeholder="请输入留言" type="textarea"></el-input>
            </div>
            <div v-if="$store.state.account !== phone"  style="display: flex !important;width: 450px;margin: 10px auto">
              <span>短信验证码:</span>
              <div class="box">
                <el-input
                    placeholder="请输入短信验证码"
                    v-model="code"
                ></el-input>
                <div class="textNum" @click="sendCode" v-if="codeText === '发送验证码'">
                  {{ codeText }}
                </div>
                <div class="text" @click="sendCode" v-else>
                  {{ codeText }}
                </div>
              </div>
            </div>
            <div style="display:flex;align-items: center;width: 450px;margin: 10px auto">
              <span style="width: 100px;">保电地址:</span>
              <el-input v-model="bdAddress" placeholder="请输入保电地址" type="textarea"></el-input>
            </div>
            <div style="display:flex;align-items: center;width: 450px;margin: 10px auto">
              <span style="width: 100px;">计划保电时间:</span>
              <el-date-picker
                    v-model="jhbdtime"
                    type="datetimerange"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    align="right"
                    style="width: 320px;margin-left: 10px" >
              </el-date-picker>
            </div>
          </div>

        </div>

        <div style="text-align: center;margin-top: 50px">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="warning" @click="confirmDialog">确 定</el-button>
        </div>

      </el-dialog>
		</div>
	</div>
</template>

<script>
import {
  carListApi,
  deleteGoodApi,
  applicationShop, addEquipmentApi,
  swapUser, getDicts
} from '../../http/api/ordinary.js'

import fa from "element-ui/src/locale/lang/fa";
import {phoneAndCodeLoginApi,sendCodeApi} from "@/http/api/user";
import {getDictByType} from "@/utils/dictUtils";

	export default {
		data() {
			return {
				list: [],
        selectedItems:[],

      //   确定服务弹窗
        shopShow:false,
      //   名称
        name:'',
      //   手机号
        phone:'',
        remark:'',
      //   发送短信验证码
        codeText:'发送验证码',
      //   短信验证码
        code:'',
      //   旧用户token
        tokenOld:'',
      //   新用户token
        tokenNew:'',
      //   ids
        ids:[],
        //字典
        dicts:{},
        dictsVolume:{},
        dictsLight:{},

        jhbdtime:[] ,
        bdAddress:'',
			};
		},
		created() {
			this.getList()
      //加载当前页面需要的字典
      this.getDict('voltage_kv')
      this.getVolume('volume_kva')
      this.getLight('lighting_type')
		},

		methods: {
      async getDict(type) {
        // this.dicts[type] = await getDictByType('voltage_kv')
        this.dicts[type] = await getDictByType(type)
      },
      async getVolume(type){
        this.dictsVolume[type] = await getDictByType(type)
      },
      async getLight(type){
        this.dictsLight[type] = await getDictByType(type)
      },
      //根据字典类型和 字典value 获取 字典label
      getDy(type,val) {
        try {
          const res = this.dicts[type]

          const matchedItem = res.find(item => item.dictValue == val).dictLabel

          return matchedItem
        } catch (error) {

        }
      },
      getSb(type,val){
        try {
          const res = this.dictsLight[type]
          const matchedItem = res.find(item => item.dictValue == val).dictLabel
          return matchedItem
        } catch (error) {

        }
      },
      getRl(type,val){
        try {
          const res = this.dictsVolume[type]
          const matchedItem = res.find(item => item.dictValue == val).dictLabel
          return matchedItem
        } catch (error) {

        }
      },

      // getDy(val){
      //   let dy = ''
      //   getDictByType(
      //       'voltage_kv'
      //   ).then(res => {
      //      dy =  res.find(item => item.dictValue == val).dictLabel
      //   })
      //   return dy
      // },
      closeDialog(){
        this.handleClose()
      },
      // 确认提交
      confirmDialog(){

        if(this.$store.state.account !== this.phone){
          this.tokenOld = this.$store.state.token
          // 新用户注册并登录
          phoneAndCodeLoginApi({
            phone: this.phone,
            code: this.code
          }).
          then(res => {
            this.$store.dispatch('Login', res);
            this.tokenNew = this.$store.state.token
            if(this.tokenOld !== this.tokenNew){
              swapUser({
                curUserToken:this.tokenOld,
                targetUserToken:this.tokenNew,
                ids:this.ids
              }).then(res=>{
                this.application()
              })
            }
          });
        }
        else{
          this.application();
        }


      },
      application(){
        applicationShop({
          shoppingTrolleyIds:this.ids,
          name:this.name,
          phone:this.phone,
          remark:this.remark,
          bdAddress:this.bdAddress,
          jhbdStartTime:this.jhbdtime[0],
          jhbdEndTime:this.jhbdtime[1],
        }).then(res=>{
          if(this.tokenOld !== this.tokenNew){
            this.$message.success('操作成功，即将登录新注册的账号')
            setTimeout(() => {
              this.$router.go(0) // 使用路由刷新
            }, 1000)
          }else {
            this.$message.success('操作成功')
            setTimeout(() => {
              this.$router.go(0) // 使用路由刷新
            }, 1000)
          }
        })
      },
      // 手机验证
      validatePhone(phone) {
        // 中国大陆手机号校验
        const chineseRegex = /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
        // 国际手机号宽松校验（以+开头，4-15位数字）
        const internationalRegex = /^\+\d{4,15}$/;

        return chineseRegex.test(phone) || internationalRegex.test(phone);
      },
      // 发送验证码
      sendCode(){
        if (typeof this.codeText != "number") {
          if (!this.validatePhone(this.phone)) {
            this.$message.error("请输入正确的手机号"); // 提示用户
            return; // 终止执行
          }
          this.codeText = 60;
          var time = setInterval((res) => {
            if (this.codeText > 0) {
              this.codeText--;
            }
            if(this.codeText == 0){
              clearInterval(time)
              this.codeText = '发送验证码';
            }
          }, 1000);

          //发送验证码
          sendCodeApi({
            phone: this.phone,
            type: "login",
          }).then((res) => {
            this.$message({
              type: "success",
              message: "短信发送成功",
            });
          });
        }
      },


      // 关闭服务弹窗
      handleClose(){
        this.shopShow = false
        this.codeText ='发送验证码'
        this.phone = ''
        this.name = ''
        this.remark = ''
        this.bdAddress = ''
        this.time1 = []
      },

      // 单选框选择
      handleCheckChange(val){
        const index = this.selectedItems.findIndex(item => item.id === val.id)

        if (index !== -1) {
          // 存在则删除
          this.selectedItems.splice(index, 1)
        } else {
          // 不存在则添加
          this.selectedItems.push(val)
        }
      },

      // 数量加减
      updataNum(val){
        addEquipmentApi({
          id:val.id,
          archiveId: val.archive.id,
          number:val.number
        }).then(res => {

          this.getList()
        })
      },

			getList() {
				carListApi().then(res => {
					this.list = res

          // this.list.forEach(item=>{
          //   item.voltageDictLabel = this.getDy(item.voltageDictLabel)
          // })


          // getDictByType('volume_kva').then(res => {
          //   this.list.orderArchiveList.forEach(val=>{

          //     val.archive.volumeDictValue = res.find(item => item.dictValue == val.archive.volumeDictValue).dictLabel
          //
          //   })
          //   // this.volume = res.find(item => item.dictValue === this.detail.volumeDictValue).dictLabel
          // })

				})
			},
			toDetail(id, type) {

				// this.$router.push({
				// 	path: type == 0 ? '/ordinaryUser/rentDetail' : '/ordinaryUser/emergencyDetail',
				// 	query: {
				// 		id: id,
				// 		changeEq: 0
				// 	}
				// })
        this.$router.push({
          path: '/ordinaryUser/rentDetail',
          query: {
            id: id.archiveId,

          }
        })
			},
      // 移除设备
			deleteGood(id) {
				deleteGoodApi(
					id
				).then(res => {
					this.$message({
						type: 'success',
						message: '设备移除成功'
					})
					this.getList()
				})
			},
      // 确定服务
			sumbit() {
        if(this.selectedItems.length === 0){
          this.$message({
            message: '请选择选择设备后再申请服务',
            type: 'warning'
          });
          return
        }
        if(this.selectedItems.length !== 0){
          var companyName = this.selectedItems[0].archive.customerName
        }
        this.ids = this.selectedItems.map(item=>{return item.id});

        for (const item of this.selectedItems) {
          if (companyName !== item.archive.customerName) {
            this.$message({
              message: '申请时只能选择同一家公司',
              type: 'warning'
            });
            return; // 直接终止函数执行
          }
        }

        this.shopShow = true
        this.name = this.$store.state.name
        this.phone = this.$store.state.account

        // applicationShop({
        //
        // })
				// for (let good of this.list) {
				// 	for (let item of good.goods) {
				// 		if (item.check) {
				// 			ids.push(item.goodId)
				// 		}
				// 	}
				// }

				// if (ids.length == 0) {
				// 	return this.$message('请选择设备')
				// }
				// checkOrderApi({
				// 	equipmentIds: ids.join(',')
				// }).then(res => {
				// 	if (res.code == 200) {
				// 		this.$router.push({
				// 			path: '/ordinaryUser/createCarOrder',
				// 			query: {
				// 				ids
				// 			}
				// 		})
				// 	}
				// })
			}
		}
	}
</script>

<style scoped lang="less">
	.main-box {

		padding: 0.1rem 0;
	}

	.content {
		width: 15.2rem;
		background: #ffffff;
		border-radius: 0.06rem;
		margin: 0 auto;
	}

	.title-box {
		line-height: 0.74rem;
		border-bottom: 1px solid #eaeaea;
		justify-content: space-between;
		padding: 0 0.25rem;

		span {
			font-size: 0.14rem;
			color: #434343;
		}

		.tit {
			font-size: 0.18rem;
			color: #000000;
		}
	}

	.list-header {
		height: 0.5rem;
		font-size: 0.14rem;
		color: #000000;
		justify-content: space-between;
		padding: 0 0.2rem;

		div {
			flex: 1;
			text-align: center;
			line-height: 0.5rem;
		}

		div:nth-of-type(1) {
			min-width: 3.6rem;
		}
	}

	.checkbox {
		display: flex;
		align-items: center;

		/deep/.el-checkbox__label {
			font-size: 0.14rem;
		}
	}

	.list {
		min-height: 600px;
		padding: 0 0.2rem;

		.item {
			margin-bottom: 0.2rem;
		}

		.company {
			padding: 0.1rem 0;
			align-items: center;
			font-size: 0.14rem;

			.c-img {
				width: 0.26rem;
				height: 0.26rem;
				border-radius: 0.04rem;
				margin: 0 0.1rem;
			}
		}

		.device-list {
			background: #f8f8f8;
			border-radius: 0.06rem;
			margin-top: 0.1rem;

			.device-checkall {
				padding: 0 0.36rem;
				height: 0.45rem;
				display: flex;
				align-items: center;
			}

			.devive-item {
				font-size: 0.14rem;
				padding: 0.25rem 0.36rem;
				justify-content: space-between;
				border-top: 1px solid #e9e9e9;
				align-items: center;

				.info {
					width: 330px;
					display: flex;
					align-items: center;
					justify-content: space-between;

					img {
						width: 100px;
						height: 100px;
						border-radius: 0.06rem;
					}

					.text {
						width: 200px;
						margin-left: 10px;

						p {
							font-size: 0.14rem;
							color: #4a4a4a;
							line-height: 0.28rem;
						}

						p:nth-of-type(1) {
							font-size: 0.2rem;
							color: #333333;
							font-weight: bold;
							line-height: 0.28rem;
							margin-bottom: 0.1rem;
						}
					}
				}

				.type {

					display: flex;
					align-items: center;
					font-size: 0.14rem;
					color: #000000;
				}

				.price {
					display: flex;
					align-items: center;
					font-size: 0.14rem;
					color: #ff4343;
				}

				.btns {
					display: flex;
					align-items: center;
					font-size: 0.14rem;
					color: #4b4b4b;

					span {
						margin-right: 0.36rem;
						cursor: pointer;
					}
				}
			}
		}
	}

	.bot {
		justify-content: end;
		align-items: center;
		padding: 20px 40px;

		p {
			font-size: 0.14rem;
			color: #000000;
			line-height: 0.42rem;
			margin-right: 20px;

			span {
				color: #ff6332;
			}
		}
	}

  .title {
    text-align: center;
    font-size: 20px;
    margin: 20px 0 20px;
  }
  .message {
    & > div {
      //display: flex;
      margin-bottom: 15px;
      align-items: center;
      text-align: center;

      .box {
        width: 320px;
        margin-left: 10px;
        height: 44px;
        background-color: #f8f8f8;

        border-radius: 6px;
        box-sizing: border-box;
        padding: 10px 0px;
        display: flex;

        .icon {
          width: 56px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-right: 1px solid #d9d9d9;

          img {
            width: 24px;
            height: 24px;
          }
        }

        .text {
          width: 100px;
          //display: flex;
          justify-content: center;
          align-items: center;
          border-left: 1px solid #d9d9d9;
          font-size: 14px;
          color: #9b9b9b;
          line-height: 24px;

          &:hover {
            cursor: pointer;
          }
        }

        .textNum {
          width: 100px;
          //display: flex;
          justify-content: center;
          align-items: center;
          border-left: 1px solid #d9d9d9;
          font-size: 14px;
          color: #E6A23C;

          line-height: 24px;

          &:hover {
            cursor: pointer;
          }
        }

        .el-input {
          flex: 1;

          /deep/ .el-input__inner {
            height: 24px;
            background-color: transparent;
            border-color: transparent;
          }
        }
      }

      span {
        width: 80px;
        text-align: right;
        font-size: 14px;

      }

      /deep/ .el-input {
        width: 320px;
        background-color: #f8f8f8;
        margin-left: 10px;
      }

      /deep/ .el-input__inner {
        background-color: #f8f8f8;
      }

      /deep/ .el-textarea {
        width: 320px;
        background-color: #f8f8f8;
        margin-left: 10px;
      }

      /deep/ .el-textarea__inner {
        background-color: #f8f8f8;
      }
    }
  }
  .custom-footer {
    display: flex;
    justify-content: center;
    gap: 20px; /* 按钮间距 */
  }
</style>
